import React from 'react';
import { Box, Typography } from '@mui/material';
import { PageHeader } from '@NP-Webber/crm-kit/dist/next/index.js';
import EmailAutomationsSettings from '../../components/emailDomain/EmailAutomationsSettings';

const TITLE = 'מיילים אוטומטיים';
const SUB = 'התוכן של מייל העידוד והציון, וכתובת היעד למשוב מהנבחנים';

/** מיילים אוטומטיים — new design */
export function EmailAutomationsPageNext() {
  return (
    <div className="nx-stack nx-narrow">
      <PageHeader title={TITLE} sub={SUB} />
      <EmailAutomationsSettings />
    </div>
  );
}

/** מיילים אוטומטיים — old design; the settings are crm-kit next and bring their own theme root */
export default function EmailAutomationsPage() {
  return (
    <Box sx={{ maxWidth: 960 }}>
      <Typography variant="h5" fontWeight={700} gutterBottom>{TITLE}</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>{SUB}</Typography>
      <EmailAutomationsSettings />
    </Box>
  );
}
